import {
  Center,
  CenterBasic,
  CenterCompact,
  CenterLight,
  CenterMinimal,
  CenterOlInformation,
  CenterPartial
} from '../../lib/types/models/center/center'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type CenterVersionMap = {
  FULL: Center
  COMPACT: CenterCompact
  LIGHT: CenterLight
  MINIMAL: CenterMinimal
  BASIC: CenterBasic
  PARTIAL: CenterPartial
  OL_INFORMATION: CenterOlInformation
}

export function getCenter<T extends keyof CenterVersionMap = 'FULL'>(
  id: number,
  version?: T
): Promise<CenterVersionMap[T extends keyof CenterVersionMap ? T : 'FULL']> {
  return restApiClient
    .url(
      encodeNestedObject<{ version: keyof CenterVersionMap }>(
        constructApiUrl(API.centers.get.url, { id }),
        { version: version || 'FULL' }
      )
    )
    .get<CenterVersionMap[T extends keyof CenterVersionMap ? T : 'FULL']>()
}
